// extracted by mini-css-extract-plugin
export default {"footerStyle":"styles_footerStyle__yuVQO"};